import forgeUtil from "node-forge/lib/util";
import forgeCipher from "node-forge/lib/cipher";
import aes from "node-forge/lib/aes"; //forgeCipher中会用到
import { env, Runtime } from '../common/env';

export default class ResponseUtil {
  static getEnv() {
    let _env = 'prod';
    // st和prod用一个密钥，  test用另一个
    if (env.runtime !== Runtime.Local && env.runtime !== Runtime.Test && env.runtime !== Runtime.Dev) {
      _env = 'prod';
    } else {
      _env = 'test';
    }
    return _env;
  }
  static decrypt(data) {
    const env = ResponseUtil.getEnv();
    let priKey = 'N21CnjPw6TQcR6LH';
    if (env === 'test') {
      priKey = 'DK7ud9yKeNVh4coE';
    }
    const decipher = forgeCipher.createDecipher('AES-CBC', priKey);
    const iv = '0123456789abcdef';
    decipher.start({ iv: iv });
    const base64 = forgeUtil.binary.base64;
    data = base64.decode(data);
    decipher.update(forgeUtil.createBuffer(data, 'utf-8'));
    const result = decipher.finish();
    return decipher.output.data;
  }
}